export default "__VITE_IMAGE_ASSET__6ad16336__";